(function (w) {
	"use strict";

	/**
	 * The class InvalidField is a helper for invalid field information
	 *
	 * @author Thomas Junghans
	 * @namespace ScForm
	 * @class InvalidField
	 * @param {Number} index
	 * @param {ValidationReturn} validationReturn
	 * @constructor
	 */

	function InvalidField(index,validationReturn) {
		this.init(index, validationReturn);
	}

	InvalidField.prototype = {
		constructor : InvalidField,
		init : function (index, validationReturn) {
			this.index = index;
			this.validationReturn = validationReturn;
		},

		/**
		 * @method getIndex
		 * @returns {Number}
		 */
		getIndex : function () {
			return this.index;
		},

		/**
		 *
		 * @method getVr
		 * @returns {ValidationReturn}
		 */
		getVr : function () {
			return this.validationReturn;
		},

		setField: function(field) {
			this.field = field;
			return this;
		},

		getField: function() {
			return this.field;
		}

	};

	w.ScForm = w.ScForm || {};
	w.ScForm.createInvalidField = function (isValid, message) {
		return new InvalidField(isValid, message);
	};

}(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/forms/clientlibs/shared/js/libraries/ScForm.InvalidField.js
// module id = 263
// module chunks = 0